resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function DataSanitization() {
    this.sanitizeMoney = function(value) {
        if (value == null) return value;
        value = value + "";
        return parseFloat(value.replace(/\$|,| /g, ""));
    };
    this.sanitizeDates = function(value) {
        if (value == null) return value;
        return value.replace(/\//g, "-");
    };
    this.sanitizeBoolean = function(value) {
        if (value === undefined) return value;
        if (value instanceof Array && value.length == 1) {
            value = value[0];
        }
        if (typeof value == "boolean")
            return value;
        else if (value == "true")
            return true;
        else if (value == "false")
            return false;
        else
            return null;
    }
    this.sanitizePhone = function(value) {
        if (value == null) return value;
        return value = value.replace(/\D/g,'');
    };
    this.sanitizeProvince = function(value){
        if (value == null) return value;
        switch(value) {
            case "British Columbia":
                return "BC";
            case "Alberta":
                return "AB";
            case "Manitoba":
                return "MB";
            case "New Brunswick":
                return "NB";
            case "Newfoundland and Labrador":
                return "NL";
            case "Nova Scotia":
                return "NS";
            case "Northwest Territories":
                return "NT";
            case "Nunavut":
                return "NU";
            case "Ontario":
                return "ON";
            case "Prince Edward Island":
                return "PE";
            case "Quebec":
                return "QC";
            case "Saskatchewan":
                return "SK";
            case "Yukon":
                return "YT";
            default:
                return value;
        }
    };
}